// 3rd party
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material';

// components
import { ConfirmDialogComponent } from 'app/shared/components/confirm-dialog/confirm-dialog.component';
import { LockScreenComponent } from 'app/shared/components/lock-screen/lock-screen.component';
import { PasswordDialogComponent } from 'app/shared/components/password-dialog/password-dialog.component';
import { CustomerStatusDialogComponent } from 'app/calibrations/customer-status-dialog/customer-status-dialog.component';
import { ErrorDialogComponent } from 'app/shared/components/error-dialog/error-dialog.component';
import { DataDialogComponent } from 'app/shared/components/data-dialog/data-dialog.component';
import { ReportFormDialogComponent } from 'app/reports/report-form-dialog/report-form-dialog';
import { VideoDialogComponent } from 'app/shared/components/video-dialog/video-dialog.component';
import { AllowPopupDialogComponent } from 'app/shared/components/allow-popup-dialog/allow-popup-dialog.component';

@Injectable()
export class DialogsService {

  constructor(
    private dialog: MatDialog
  ) { }

  public changePassword(): Observable<boolean> {
    let dialogRef: MatDialogRef<PasswordDialogComponent>;
    dialogRef = this.dialog.open(PasswordDialogComponent, {
      disableClose: true
    });
    return dialogRef.afterClosed();
  }

  public confirm(title: string, message: string): Observable<boolean> {

    let dialogRef: MatDialogRef<ConfirmDialogComponent>;

    dialogRef = this.dialog.open(ConfirmDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;

    return dialogRef.afterClosed();
  }

  public confirmRemove(): Observable<boolean> {

    let dialogRef: MatDialogRef<ConfirmDialogComponent>;

    dialogRef = this.dialog.open(ConfirmDialogComponent);
    dialogRef.componentInstance.title = 'Remover esse registro?';
    dialogRef.componentInstance.message = 'Esse registro será removido e não aparecerá mais na listagem.';
    dialogRef.componentInstance.buttonOk = 'REMOVER';

    return dialogRef.afterClosed();
  }

  public data(options: any[], columns: any[], data: any[], buttons: any[], component: any): Observable<any> {

    let dialogRef: MatDialogRef<DataDialogComponent>;
    dialogRef = this.dialog.open(DataDialogComponent, {
      disableClose: true,
      width: options[0].dialogWidth,
      panelClass: 'data-dialog-component'
    });
    dialogRef.componentInstance.options = options;
    dialogRef.componentInstance.data = data;
    dialogRef.componentInstance.buttons = buttons;
    dialogRef.componentInstance.columns = columns;
    dialogRef.componentInstance.component = component;
    return dialogRef.afterClosed();
  }

  public error(title: string, message: string, icon: string = 'info', iconColor: string = 'red'): Observable<boolean> {

    let dialogRef: MatDialogRef<ErrorDialogComponent>;

    dialogRef = this.dialog.open(ErrorDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;
    dialogRef.componentInstance.icon = icon;
    dialogRef.componentInstance.iconColor = iconColor;

    return dialogRef.afterClosed();
  }

  public customerStatus(lst: any[], readOnly: boolean): Observable<any> {
    let dialogRef: MatDialogRef<CustomerStatusDialogComponent>;
    dialogRef = this.dialog.open(CustomerStatusDialogComponent, {
      disableClose: !readOnly,
      width: '300px'
    });
    dialogRef.componentInstance.calibrationList = lst;
    dialogRef.componentInstance.isReadOnly = readOnly;
    return dialogRef.afterClosed();
  }

  public lockScreen(userName: string): Observable<boolean> {

    let dialogRef: MatDialogRef<LockScreenComponent>;

    dialogRef = this.dialog.open(LockScreenComponent, {
      disableClose: false,
      backdropClass: 'lock-screen-container'
    });
    dialogRef.componentInstance.userName = userName;

    return dialogRef.afterClosed();
  }

  public reportForm(report: any, customerId: number): Observable<any> {
    let dialogRef: MatDialogRef<ReportFormDialogComponent>;
    dialogRef = this.dialog.open(ReportFormDialogComponent, {
      disableClose: true,
    });
    dialogRef.componentInstance.report = report;
    dialogRef.componentInstance.customerId = customerId;
    return dialogRef.afterClosed();
  }

  public openVideoDialog(): Observable<any> {
    let dialogRef: MatDialogRef<VideoDialogComponent>;

    dialogRef = this.dialog.open(VideoDialogComponent);

    return dialogRef.afterClosed();
  }

  public openPopupDialog(): Observable<any> {
    let dialogRef: MatDialogRef<AllowPopupDialogComponent>;

    dialogRef = this.dialog.open(AllowPopupDialogComponent);

    return dialogRef.afterClosed();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/dialog/dialog.service.ts